import axios from "@/axios";

export async function getAllReasonNotFamilyInterview(params) {
  const { data } = await axios.get("/reason_interviews/filter", {
    params,
  });
  return data.data ? data.data : data;
}

export async function getReasonNotFamilyInterviewList(params) {
  const { data } = await axios.get("/reason_interviews/list", {
    params,
  });
  return data.data ? data.data : data;
}

export async function saveReasonNotFamilyInterview(id, data) {
  const method = id ? "PUT" : "POST";
  const url = id ? `/reason_interviews/${id}` : `/reason_interviews`;
  return await axios({ method, url, data: data });
}
